module.exports = __webpack_public_path__ + "media/images/icons/outlined/swap-right-08a41dd87e64f42c0586238bba07aeb3.svg";